import to from 'await-to-js'
import axios from 'axios'

export default async function phoneValidator({
  phone = '',
  country = '',
  setFieldError,
}) {
  const [error, data] = await to(
    axios.post('/.netlify/functions/phone-number', {
      phone,
      country,
    })
  )

  // If our endpoint can't be hit - assume it's valid to not block the user
  if (error || !data?.data?.valid) {
    // setFieldError isn't required so we can use it in our `<MarketoForm />` component
    if (typeof setFieldError === 'function') {
      setFieldError('phone', 'Phone number is invalid')
    }

    return { error: true }
  }

  return { error: false }
}
